import { TAnimation } from './Theme.domain';

export const animation: TAnimation = {
    animationLinear4: '400ms linear infinite',
};
